import IUpdatePasswordForm from "@shared/entities/Dashboard/IUpdatePasswordForm";
import { useHttpService } from "@shared/services";
import { useCallback } from "react";

/** 使用者自己 */
export function useMeApi() {
  const http = useHttpService();

  /** 變更使用者語言 */
  const ChangeLanguage = useCallback(
    async (userLanguage: string) => {
      return (
        await http.put<{
          success: boolean;
        }>("/me/language", {
          userLanguage,
        })
      ).data;
    },
    [http]
  );

  /** --更新我自己(WTF)-- 更新使用者資料 */
  const UpdateMe = useCallback(
    async (formValues: {
      userPhone: string;
      userIdentificationNumber: string;
      userRealname: string;
      userNickname: string;
      userBirthday: string;
      userCountry: string;
      userGender: string;
    }) => {
      return (
        await http.put<{
          success: boolean;
        }>("/me/", formValues)
      ).data;
    },
    [http]
  );

  /** 更新密碼 */
  const UpdatePassword = useCallback(
    async (formValues: IUpdatePasswordForm) => {
      return (
        await http.put<{
          success: boolean;
        }>("/me/password", formValues)
      ).data;
    },
    [http]
  );
  /** 更新密碼 */
  const UpdateNickname = useCallback(
    async (formValues: { userNickname: string }) => {
      return (
        await http.put<{
          success: boolean;
        }>("/me/nickname", formValues)
      ).data;
    },
    [http]
  );

  /** 
   * 取得使用者的 OAuth 狀態 
   * 
   * data 將會隨著 OAuth 之服務是否啟用而有不同的內容，eg. { google: true, facebook: false }
   * 
   */
  const GetOAuthStatus = useCallback(async () => {
    return (await http.get<{
      success: boolean;
      data: { [provider: string]: boolean }
    }>('/me/oauth')).data
  }, [http])

  /**
   * 取得 OAuth 綁定網址
   */
  const GetOAuthBindURL = useCallback(async (provider = 'google') => {
    return (await http.get<{
      success: boolean;
      data: { url: string }
    }>(`/me/oauth/${provider}/bind`)).data
  }, [http])

  /**
   * OAuth 綁定回傳
   */
  const BindOAuth = useCallback(async (code: string, provider = 'google',) => {
    return (await http.post<{
      success: boolean;
    }>(`/me/oauth/${provider}/callback`, { code })).data
  }, [http])
  /**
   * OAuth 綁定回傳
   */
  const UnBindOAuth = useCallback(async (provider = 'google',) => {
    return (await http.delete<{
      success: boolean;
    }>(`/me/oauth/${provider}`)).data
  }, [http])

  /** 這裡導出可以用的API函數！ */
  return { ChangeLanguage, UpdateMe, UpdatePassword, UpdateNickname, GetOAuthStatus, GetOAuthBindURL, BindOAuth, UnBindOAuth };
}
